import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useReprintCertificate as useReprintCertificateAPI } from "../../../../fnx/reprint/reprintCertificateTypeQuote";
import { reprintCertificateTypeClearData } from "../../../../store/reprintCertifacatesQuote/actions";
export var useReprintCertificateManagement = function (_a) {
    var triggerReprint = _a.triggerReprint, quoteId = _a.quoteId, setTriggerReprint = _a.setTriggerReprint, onReprintSuccess = _a.onReprintSuccess;
    var dispatch = useDispatch();
    var _b = useReprintCertificateAPI(triggerReprint, quoteId || "", "QUICK_PRINT", function () {
        return setTriggerReprint(false);
    }), responseReprintType = _b.responseReprintType, loadingReprintType = _b.loadingReprintType, errorReprintType = _b.errorReprintType;
    useEffect(function () {
        if (responseReprintType) {
            onReprintSuccess();
            dispatch(reprintCertificateTypeClearData());
        }
    }, [responseReprintType]);
    return {
        responseReprintType: responseReprintType,
        loadingReprintType: loadingReprintType,
        errorReprintType: errorReprintType,
    };
};
